export const EMBEDDED_MODE = {
    TV: 'tv',
    EMBEDDED: 'embedded',
};
